import { useContext } from 'react'
import './bottom.css';
import { Link } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home';
import GroupIcon from '@mui/icons-material/Group';
import { Notifications } from "@mui/icons-material";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import SocialContext from '../../context/SocialContext';

export default function Bottom() {
    const { unreadnotification } = useContext(SocialContext);

    const scrolatTopfun = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <div className="bottom">
                <div className="bottomIcon">
                    <Link style={{ 'textDecoration': 'none' }} className='bottomIconlink' onClick={scrolatTopfun} to={'/'}><HomeIcon style={{ color: "black", "height": '25px' }} />
                        <p>Home</p></Link>
                </div>
                <div className="bottomIcon">
                    <Link style={{ 'textDecoration': 'none' }} className='bottomIconlink' to={'/share'}><AddBoxOutlinedIcon style={{ color: "black", "height": '25px' }} />
                        <p>Post</p></Link>
                </div>
                <div className="bottomIcon">
                    <Link style={{ 'textDecoration': 'none' }} className='bottomIconlink' to={'/friends'}><GroupIcon style={{ color: "black", "height": '25px' }} />
                        <p>Network</p>
                    </Link>
                </div>
                <div className="bottomIcon">
                    <Link style={{ 'textDecoration': 'none' }} className='bottomIconlink' to={`/notifications/${window.localStorage.getItem('currentUID')}`}><Notifications style={{ color: "black", "height": '25px' }}></Notifications>
                        <p>Notification {unreadnotification > 0 ? <span className='unreadnoticount'>{unreadnotification}</span> : ''}</p>
                    </Link>
                </div>
                <div className="bottomIcon">
                    <Link style={{ 'textDecoration': 'none' }} className='bottomIconlink' to={'/menu'}><MenuIcon style={{ color: "black", "height": '25px' }} />
                        <p>Menu</p>
                    </Link>
                </div>
            </div>
        </>
    )
}
